import {
  dedupeIntegration,
  defaultStackParser,
  functionToStringIntegration,
  httpContextIntegration,
  inboundFiltersIntegration,
  linkedErrorsIntegration,
  makeFetchTransport,
} from '@sentry/browser';
import type { SentryConfiguration } from './types/SentryConfiguration';
import { defaultClientName } from '@thesavingsgroup/reporting';

const isProduction = import.meta.env.PROD === true;

const profilesSampleRate = isProduction ? 0.1 : 1;
const sampleRate = isProduction ? 0.1 : 1;
const tracesSampler = () => (isProduction ? 0.1 : 1);
const tracesSampleRate = isProduction ? 0.1 : 1;

const defaultConfiguration = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: true,
  environment: import.meta.env.MODE,
  integrations: [
    inboundFiltersIntegration(),
    functionToStringIntegration(),
    linkedErrorsIntegration(),
    dedupeIntegration(),
    httpContextIntegration(),
  ],
  profilesSampleRate,
  release: import.meta.env.VITE_APPLICATION_VERSION,
  sampleRate,
  stackParser: defaultStackParser,
  tracesSampler,
  tracesSampleRate,
  transport: makeFetchTransport,
};

const configMap = new Map<string, SentryConfiguration>();

export const getConfigFor = (
  name: string = defaultClientName,
): SentryConfiguration => {
  if (configMap.has(name)) {
    return configMap.get(name)!;
  }

  const config = {
    ...defaultConfiguration,
    dist: name,
  };

  configMap.set(name, config);

  return config;
};
